export async function GetAsyncStorage() {
  return null;
}
